import React from 'react'
import { t } from '@lingui/macro'

import ResettableInput from '../../../components/common/form/input/ResettableInput'

export interface IProps {
  search: string
  onSearchChange: (value: string) => void
}

const Filters = (props: IProps) => {
  const { search, onSearchChange } = props

  return (
    <ResettableInput
      onChange={onSearchChange}
      placeholder={t`Search`}
      title={t`Search`}
      showResetButton={!!search}
      showSearchIcon={true}
      light={true}
      value={search}
      onReset={() => onSearchChange('')}
    />
  )
}

export default Filters
